import React, { Component } from 'react';
import { Parallax, ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax';
import LivingRoomOne435 from './GalleryPhotos/135_ExteriorWhiteHall.jpg';

class HalfBackgroundParallax extends Component {
  render(){
    var p = this.props, s = this.state;
    return (
      <div>
        <ParallaxBanner layers={[{image: LivingRoomOne435, amount: 0.2, slowerScrollRate: true}]} />
      </div>
    )
  }
}

export default HalfBackgroundParallax;

var style = {
  frame: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  parent: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'table',
    margin: 'auto'
  }
}

const ParallaxBannerImage = () => {
  return (
      <ParallaxBanner style={{height: '100%'}} layers={[{image: LivingRoomOne435, amount: 0.2, slowerScrollRate: true}]}></ParallaxBanner>
  )
}



// WEBPACK FOOTER //
// ./src/HalfBackgroundParallax.js